import React, { Component } from 'react';
import { Modal, ModalOpen, ModalClose } from '../Modal';
import { Spinner } from 'reactstrap';
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import API from '../API';
import { formatPrice } from '../c/PremiumKeys/Globals/GlobalUtils';

export function OrderActionsModalInit({ order, onSuccess }) {
  ModalOpen('OrderActionsModal', { order, onSuccess });
}

class OrderActionsInnerContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refundLoading: false,
      refundSuccess: false,
      refundError: null
    };
    this.handleRefundFullOrder = this.handleRefundFullOrder.bind(this);
  }

  handleRefundFullOrder() {
    const { order, onSuccess } = this.props;
    if (!window.confirm("Are you sure you want to refund this order?")) return;

    this.setState({ refundLoading: true, refundError: null });
    API.post("/a/refund_order", { orderId: order.OrderId }, (response, status) => {
      this.setState({ refundLoading: false });
      if (status === 200) {
        this.setState({ refundSuccess: true }, () => {
          onSuccess && onSuccess();
        });
      } else {
        this.setState({ refundError: "Refund failed. Please try again." });
      }
    });
  }

  render() {
    const { order } = this.props;
    const { refundLoading, refundSuccess, refundError } = this.state;

    if (!order) return null;

    return (
      <div className="ad_trade_bg p-4">
        {(!refundLoading && !refundSuccess) && (
          <React.Fragment>
            <div className="ad_150pct"><b><T>Order details</T></b></div>
            <div className="mt-2"><b><T>Order id: </T></b><span>{order.Id}</span></div>
            <div className="mt-2"><b><T>Payment gateway id: </T></b><span>{order.OrderId}</span></div>
            <div className="mt-2">
              <b><T>Order value: </T></b>
              <span>{formatPrice(order.Amount)} {order.Currency}</span>
            </div>
          </React.Fragment>
        )}

        {(order.Status === "Captured" || order.Status === "PartiallyCaptured") ? (
          refundLoading ? (
            <div className="text-center my-3">
              <Spinner />
              <div><T>Processing refund...</T></div>
            </div>
          ) : refundSuccess ? (
            <div className="text-center my-3"><T>Order refunded successfully</T></div>
          ) : (
            <React.Fragment>
              <div className="mt-4 ad_125pct"><T>Refund order</T></div>
              <div className="pb-2 py-2 font-small"><T>Refund the full order value</T></div>
              <button
                className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
                onClick={this.handleRefundFullOrder}
              >
                <T>Refund order</T>
              </button>
              {refundError && (
                <div className="text-center text-danger mt-2"><T>{refundError}</T></div>
              )}
            </React.Fragment>
          )
        ) : (
          <div className="pb-2 py-2 font-small">
            <T>Order status must be Captured or PartiallyCaptured to refund</T>
          </div>
        )}

        <div>
          <button
            onClick={ModalClose}
            className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light mt-4"
          >
            <T>Close</T>
          </button>
        </div>
      </div>
    );
  }
}

const OrderActionsInner = props => (
  <AUAContainer>
    <OrderActionsInnerContent {...props} />
  </AUAContainer>
);

export class OrderActionsModal extends Modal {
  allow_close_via_ui() { return true; }
  get_name() { return "OrderActionsModal"; }
  get_fullscreen_bg_class() { return "ad_signuplogin_dark"; }
  get_fullscreen() { return true; }
  mrender() { return <OrderActionsInner {...this.props} />; }
}



// WEBPACK FOOTER //
// ./src/c/OrderActionsModal.js